import React from 'react';
import BlastResults from './BlastResults';

function SmsBlastResults() {
    return (
        <BlastResults
            listPath="/blast/sms"
            listLabel="Past SMS Blast"
            channelLabel="SMS"
            icon="bi-chat-dots"
        />
    );
}

export default SmsBlastResults;
